
import React from 'react';
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Group } from '@/types/note';
import HierarchicalGroupSelector from './HierarchicalGroupSelector';
import { useAIHighlightPreference } from '@/hooks/useAIHighlightPreference';

interface EditorActionsProps {
  selectedGroup: string;
  groups: Group[];
  onGroupChange: (groupId: string) => void;
  onSave: () => void;
  isSaving: boolean;
}

const EditorActions: React.FC<EditorActionsProps> = ({
  selectedGroup,
  groups,
  onGroupChange,
  onSave,
  isSaving,
}) => {
  const [showAIHighlights, setShowAIHighlights] = useAIHighlightPreference();

  return (
    <div className="flex justify-between items-center mt-4 gap-4 flex-wrap">
      <HierarchicalGroupSelector
        selectedGroup={selectedGroup}
        groups={groups}
        onGroupChange={onGroupChange}
      />
      <div className="flex items-center gap-3">
        <Label
          htmlFor="show-ai-highlights"
          className={`flex items-center gap-2 text-sm cursor-pointer rounded-md border px-2.5 py-1.5 transition-colors ${
            showAIHighlights
              ? 'border-primary bg-primary/10 text-primary'
              : 'border-border bg-muted text-muted-foreground'
          }`}
        >
          <Switch
            id="show-ai-highlights"
            checked={showAIHighlights}
            onCheckedChange={setShowAIHighlights}
          />
          <span className="font-medium">
            AI edit highlights: {showAIHighlights ? 'ON' : 'OFF'}
          </span>
        </Label>
        <Button onClick={onSave} disabled={isSaving} data-tour="save-note">
          {isSaving ? 'Saving...' : 'Save Note'}
        </Button>
      </div>
    </div>
  );
};

export default EditorActions;
